import React from 'react'
import { Link } from 'react-router-dom'

const Post = ({post}) => {
  return (
    <>
     <div className="lws-card">
    <Link to={`/blog/${post?.id}`}>
      <img src={post?.image} className="lws-card-image" alt />
    </Link>
    <div className="p-4">
      <div className="lws-card-header">
        <p className="lws-publishedDate">{post?.createdAt}</p>
        <p className="lws-likeCount"><i className="fa-regular fa-thumbs-up" />{post?.likes}</p>
      </div>
      <Link to={`/blog/${post?.id}`} className="lws-postTitle"> {post?.title} </Link>
      <div className="lws-tags"> {post?.tags?.map(tag=>( <span>#{tag} </span>))} </div>
      {/* Show this element if post is saved */}
    {post?.isSaved &&  <div className="flex gap-2 mt-4">
        <span className="lws-badge"> Saved </span>
      </div>}
      {/* Show this element if post is saved Ends */}
    </div>
  </div>
    </>
  )
}

export default Post